import React from "react";
import styled from "styled-components";

export const CommentSplitUp = ({ data }) => {
  const { comments } = data;

  return (
    <Container>
      <CommentCard>
        <CommentContent>
          <Label>Comments</Label>
          <Value>{comments || "No comments available"}</Value>
        </CommentContent>
      </CommentCard>
    </Container>
  );
};

export const Container = styled.div`
  padding: 20px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;

  @media (min-width: 768px) {
    padding: 30px 40px;
  }
`;

export const CommentCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  gap: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #d1d5db;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 16px;
  }
`;

export const CommentContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Label = styled.div`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
`;

export const Value = styled.div`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 14px;
  color: #293461;
  line-height: 1.6;
  word-break: break-word;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;
